import { render, staticRenderFns } from "./SubscriptionVariantsDataTable.vue?vue&type=template&id=b802125c"
import script from "./SubscriptionVariantsDataTable.vue?vue&type=script&lang=js"
export * from "./SubscriptionVariantsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports